<div class="flex max-w-screen-sm items-center justify-between border-b border-neutral-300 py-3">
  <div class="mr-2 flex flex-1 items-start gap-2">
    @if (icon) {
      <div
        class="icon {{ icon }} px-2"
        [style.color]="secondaryTextColor | contentBuilderColor"
      ></div>
    }
    @if (!mustTranslate) {
      <p
        class="text-base font-normal"
        [style.color]="textColor | contentBuilderColor"
      >
        {{ text }}
      </p>
    }
    @if (mustTranslate) {
      <p class="text-base font-normal">{{ text | translate }}</p>
    }
  </div>
  <div class="text-right text-base leading-5 whitespace-nowrap">
    <app-price-atom
      [bold]="false"
      [amount]="price"
      [format]="true"
    ></app-price-atom>
  </div>
</div>
